<script lang="ts">
  import type { OrderOption } from "../../models/order-options.interface";
  import { orderStore } from "../../services/order-options-service";
  import OptionRow from "./OptionRow.svelte";

  const id = "pages";
  export let option: OrderOption;

  // Default options
  orderStore.setOrderValue(
    id,
    option.params.defaultValues.map((dv) => {
      return {
        id: id,
        value: dv,
        selected: true
      };
    })
  );

  function handleCheckboxChange(selectedValue: string, event) {
    if (event.target.checked){
      orderStore.setOrderValue(id, [...$orderStore.values[id], {
        id: id,
        value: selectedValue,
        selected: true
      }]);
    } else {
      orderStore.setOrderValue(id, $orderStore.values[id].filter(v => v.value !== selectedValue));
    }
  }
</script>

<OptionRow
  {id}
  label="Include Pages"
  tooltip="Select pages to be included from the available options."
>
  <div class="checkbox-container">
    {#each option.params.values as possibleValue}
      <div class="checkbox-items">
        <input
          type="checkbox"
          class="form-check-input"
          name={id}
          id="{id}-{possibleValue}"
          checked={$orderStore.values[id]?.find((o) => o.value === possibleValue)?.selected}
          on:change={e => handleCheckboxChange(possibleValue, e)}
        />
        <label class="form-check-label ms-2" for="{id}-{possibleValue}">
          {possibleValue}
        </label>
      </div>
    {/each}
  </div>
</OptionRow>

<style>
  .checkbox-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .checkbox-items {
    display: flex;
    align-items: center;
  }
</style>
